import React, { useEffect, useState } from 'react'
import { Grid, InputLabel, Typography } from '@mui/material';
import TextField from '../../components/TextField';


const LayoutFill = ({ details, answerLabels, setAnswerLabels }) => {

    const [blanksCount, setBlanksCount] = useState(0);
    const [charLimits, setCharLimits] = useState([])

    useEffect(() => {
        const countBlanksAndSetLimits = (text) => {
            const regex = /{(\d+)}/g;
            const matches = [...text.matchAll(regex)];
            const limits = matches.map(match => parseInt(match[1], 10))
            return { count: matches.length, limits };
        }

        if (details?.text) {
            const { count, limits } = countBlanksAndSetLimits(details.text);
            setBlanksCount(count);
            setCharLimits(limits);
        }
    }, [details?.text])

    const handleChange = (index, value) => {
        const newAnswers = [...answerLabels];
        newAnswers[index] = value;
        setAnswerLabels(newAnswers);
    }

    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <Grid item xs={12}>
                    <Typography
                        align="left"
                        variant="h6"
                        color="primary.blue"
                        sx={{
                            margin: '0',
                            fontWeight: '700',
                            lineHeight: '1.5',
                        }}>Answers <span style={{ color: 'red' }}>*</span> </Typography>
                </Grid>
            </Grid>
            {Array.from({ length: blanksCount }).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index} >
                    <InputLabel style={styles.inputLabel}>Answer {index + 1}</InputLabel>
                    <TextField
                        name={`answer-${index}`}
                        fullWidth
                        value={answerLabels[index] || ''}
                        onChange={(e) => handleChange(index, e.target.value)}
                        placeholder={`Enter Answer ${index + 1}`}
                        required
                        InputProps={{ inputProps: { maxLength: charLimits[index] || '' } }}
                    />
                </Grid>
            ))}
        </React.Fragment>
    )
}

const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    gridContainer: {
        mt: 2,
    },
    suggestionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px',
    },
    suggestionItem: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '2px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
        backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
    },
    uploadBtn: {
        width: '50px',
        height: '50px',
        borderRadius: '5px',
    },
    hiddenInput: {
        display: 'none',
    }
};

export default LayoutFill